import styled from 'styled-components'
import { ASSETS } from '../../../constants/assets'

export const QuoteOuter = styled.div<{ $quoteTheme: string }>`
  ${({ theme, $quoteTheme }: any) => {
    let quoteFill, dottedGridColor, bgColor, quoteBGImageStyles

    if ($quoteTheme === 'Light') {
      quoteFill = theme.webMktNewPalette.deepBlue[15]
      dottedGridColor = theme.webMktNewPalette.black
      bgColor = theme.webMktNewPalette.white
    } else if ($quoteTheme === 'Grey') {
      quoteFill = theme.webMktNewPalette.white
      dottedGridColor = theme.webMktNewPalette.black
      bgColor = theme.webMktNewPalette.deepBlue[10]
    } else if ($quoteTheme === 'Dark') {
      quoteFill = theme.webMktNewPalette.alphaWhite[10]
      dottedGridColor = theme.webMktNewPalette.alphaWhite[50]
      bgColor = theme.webMktNewPalette.deepBlue[70]
    }

    quoteBGImageStyles = `
        top: 96px;

        ${theme.breakpoints.down('sm')} {
          top: 64px;
        }

        ${theme.breakpoints.down('xs')} {
          top: 338px;
        }
      `

    return `
      background: ${bgColor};

      .Quote__Image-Container:before {
        background-image: radial-gradient(${dottedGridColor} 1px, transparent 0);
      }

      #Quote__Bg-Image-Inner {
        fill: ${quoteFill};
      }

      .Quote__Text,
      .Quote__Text h6,
      .Quote__Text p {
        color: ${
          $quoteTheme === 'Light' || $quoteTheme === 'Grey'
            ? theme.webMktNewPalette.black
            : theme.webMktNewPalette.white
        }
      }

      .Quote__Bg-Image {
        ${quoteBGImageStyles}
      }

      ${theme.breakpoints.down('xs')} {
        padding-left: 16px;
        padding-right: 16px;
      }
    `
  }}
`

export const BlogQuoteWHeadshot = styled.div`
  && {
    background-color: ${({ theme }) => theme.webMktNewPalette.white};
    position: relative;
    margin: 80px 0 124px 0;
    border-left: 0;
    padding: 48px;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      margin: 80px 0 92px 0;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding: 48px 24px;
      margin: 80px 0 124px 0;
    }

    &:before {
      content: '';
      position: absolute;
      top: -30px;
      left: 48px;
      width: 74px;
      height: 56px;
      background-image: url(${ASSETS.BLOCKQUOTE});
    }

    p {
      color: #273139;
    }

    p:last-child,
    p:last-child span {
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      margin-top: 32px;
    }

    p:first-child {
      font-size: 24px;
      line-height: 36px;
      font-weight: 400;
      letter-spacing: -0.5px;
      margin-bottom: 32px;

      ${({ theme }) => theme.breakpoints.down('md')} {
        font-size: 20px;
        line-height: 32px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        font-size: 20px;
        line-height: 32px;
        letter-spacing: 0px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        font-size: 20px;
        line-height: 32px;
        letter-spacing: 0px;
      }
    }
  }

  .BlockQuote__Byline {
    max-width: 306px;
    margin: 0 0 0 184px !important;

    ${({ theme }) => theme.breakpoints.down('md')} {
      max-width: 188px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: 300px;
      margin: 0 0 0 152px !important;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 100%;
      margin: 0 !important;
    }
  }

  .BlockQuote__Headshot-Img {
    width: 160px;
    height: 160px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0 24px 0 0;
    position: absolute;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 128px;
      height: 128px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: 96px;
      height: 96px;
      margin: 0;
      bottom: -64px;
    }

    .BlockQuote__Headshot-Img-File {
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
    }
  }
`

export const QuoteInner = styled.div`
  position: relative;
  padding: 96px 0 160px 0;
  max-width: 996px;
  margin: 0 auto;

  ${({ theme }) => theme.breakpoints.down('md')} {
    max-width: 796px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    max-width: 736px;
  }
  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 64px 0 104px 0;
    max-width: 329px;
  }
  .Quote__Bg-Image {
    width: 282px;
    height: 211px;
    position: absolute;
    right: 0;
    z-index: 0;

    ${({ theme }) => theme.breakpoints.down('md')} {
      width: 222px;
      height: 166px;
      right: -84px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 173px;
      height: 129px;
      right: 0;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: 156px;
      height: 116px;
    }
  }

  .Quote__Inner {
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: flex-start;
    justify-content: space-between;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column;
    }

    .Quote__Image-Container {
      position: relative;
      flex-basis: 282px;
      width: 282px;
      height: 282px;
      flex-shrink: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      ${({ theme }) => theme.breakpoints.down('md')} {
        height: 221px;
        width: 221px;
        flex-basis: 221px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        height: 172px;
        width: 172px;
        flex-basis: 172px;
        margin-left: 42px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        height: 242px;
        width: 242px;
        flex-basis: 242px;
        margin-left: 0;
      }

      &:before {
        content: '';
        position: absolute;
        width: 205px;
        height: 205px;
        z-index: 0;
        right: -64px;
        bottom: -64px;
        background-size: 24px 24px;

        ${({ theme }) => theme.breakpoints.down('md')} {
          height: 159px;
          width: 159px;
          right: -48px;
          bottom: -48px;
        }

        ${({ theme }) => theme.breakpoints.down('sm')} {
          right: -40px;
          bottom: -40px;
        }

        ${({ theme }) => theme.breakpoints.down('xs')} {
          height: 178px;
          width: 181px;
          right: -64px;
          bottom: 32px;
        }
      }
    }

    .Quote__Image {
      position: relative;
      z-index: 1;
      height: 100%;
      width: auto;
      min-width: 100%;
      object-fit: cover;
    }

    .Quote__Text {
      flex-basis: 588px;
      flex-shrink: 1;
      margin-left: 126px;
      margin-right: auto;

      ${({ theme }) => theme.breakpoints.down('md')} {
        width: 468px;
        flex-basis: 468px;
        margin-left: 106px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        width: 454px;
        flex-basis: 454px;
        margin-left: 23px;
        margin-right: 0;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        margin-left: 0;
        margin-top: 24px;
        width: 100%;
        flex-basis: 100%;
      }

      .Quote__Author {
        margin-top: 24px;
      }

      .Quote__Title {
        margin-top: 3px;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin-top: 8px;
        }
      }

      .Quote__CTA {
        margin-top: 21px;

        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin-top: 16px;
        }
      }
    }
  }

  &.Quote__Slider.Quote__Slider {
    .Quote__Bg-Image {
      top: 184px;

      ${({ theme }) => theme.breakpoints.down('sm')} {
        top: 144px;
      }

      ${({ theme }) => theme.breakpoints.down('xs')} {
        top: 338px;
      }
    }

    .Quote__Text {
      max-width: 819px;
      margin-left: 0;
    }

    .Quote__Image {
      position: absolute !important;
      top: 0;
      left: 0;
    }

    .slick-slide {
      overflow: hidden;
      opacity: 0;
      transition: opacity 240ms cubic-bezier(0.4, 0.14, 0.3, 1) 75ms;

      &.slick-current {
        opacity: 1;
        transition: opacity 240ms cubic-bezier(0.4, 0.14, 0.3, 1) 245ms;
      }
    }

    .Quote__Text {
      flex-basis: unset;
      width: auto;
      position: relative;
    }

    .Quote__Image {
      opacity: 0;
      transition: opacity 240ms cubic-bezier(0.4, 0.14, 0.3, 1);

      &.Quote__Image--Active {
        transition: opacity 240ms cubic-bezier(0.4, 0.14, 0.3, 1);
        opacity: 1;
      }
    }

    .Quote__Slider-Item {
      margin-left: 126px;
      max-width: 588px;

      ${({ theme }) => theme.breakpoints.down('md')} {
        max-width: 468px;
      }

      ${({ theme }) => theme.breakpoints.down('sm')} {
        max-width: 454px;
      }
    }

    .Quote__Slider-Nav-Container {
      margin-left: 126px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      .Quote__Slider-Nav-Container,
      .Quote__Slider-Item {
        margin-left: 70px;
      }
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      .Quote__Slider-Nav-Container,
      .Quote__Slider-Item {
        margin-left: 0px;
      }

      .Quote__Text {
        max-width: 328px;
      }

      .Quote__Slider-Item {
        max-width: 328px;
      }
    }
  }

  .Quote__Slider-Nav-Container {
    margin: 0 0 32px 0;
    display: flex;
    flex-direction: row;
    align-items: center;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin: 12px 0 24px 0;
      z-index: 2;
      position: relative;
    }

    .Quote__Slider-Prev-Button,
    .Quote__Slider-Next-Button {
      padding: 0;
      .MuiIconButton-label {
        img {
          width: 56px;
          height: 56px;

          ${({ theme }) => theme.breakpoints.down('md')} {
            width: 48px;
            height: 48px;
          }
        }
      }
    }

    .Quote__Slider-Slide-Position {
      margin: 0 16px;
      font-size: 20px;
      font-weight: normal;
      letter-spacing: -0.5px;
      line-height: 32px;
    }
  }
`

export const LogoQuoteInner = styled.div`
  position: relative;
  padding: 128px 32px 96px 32px;
  max-width: 2560px;
  margin: 0 auto;

  .Logo-Slider-Outer {
    margin: 64px auto 0;
    max-width: 1836px;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    grid-column-gap: 24px;

    .slick-list {
      margin: 0 -26px;
    }
  }

  .Logo-Slider {
    grid-column: 3 / 11;
  }

  .Logo-Slider-Item img {
    filter: grayscale(1);
    opacity: 0.5;
    transition: all 300ms ease;
    cursor: pointer;
    pointer-events: auto;
    background: #fff;
    margin: 0 auto;
    width: 100%;
    width: calc(100% - 52px);

    &:hover,
    &.Logo-Slider-Item--Active {
      filter: grayscale(0);
      opacity: 1;
      box-shadow: 0px 16px 16px ${({ theme }) => theme.webMktNewPalette.alphaBlack[10]};
    }
  }

  .Quote__Inner {
    position: relative;
    max-width: 1836px;
    margin: 0 auto;
  }

  .Quote__Text {
    position: relative;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    grid-column-gap: 24px;
    align-items: center;
  }

  .Quote__Slider-Outer {
    grid-column: 3 / 11;

    .slick-track {
      display: flex;
      align-items: center;
    }
  }

  .Quote__Slider-Prev-Button-Container,
  .Quote__Slider-Next-Button-Container {
    position: relative;

    button {
      width: 48px;
      height: 48px;
      padding: 0;
    }

    .MuiIconButton-label {
      width: 100%;
      height: 100%;
    }
    .Quote__Slider-Button-Circle {
      width: 48px;
      height: 48px;
    }
  }

  .Quote__Slider-Prev-Button-Container {
    grid-column: 2;
    margin-right: auto;
  }

  .Quote__Slider-Next-Button-Container {
    grid-column: 11;
    margin-left: auto;
  }

  .Quote__Slider-Item-Inner {
    align-items: center;
    justify-content: center;
    justify-content: center;
    display: grid;
    grid-template-columns: repeat(8, minmax(0, 1fr));
    grid-column-gap: 24px;
  }

  .Quote__Slider-Item-Details {
    grid-column: 1 / 6;
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        margin-right: 16px;
        width: 126px;
        height: 64px;
        object-fit: contain;
      }
    }
  }

  .Quote__Body-Text {
    margin: 0 0 32px;
  }

  .Quote__Author {
    margin: 0 0 4px;
  }

  .Quote__Slider-Item-Image-Container {
    border-radius: 50%;
    object-fit: cover;
    grid-column: 6 / 9;
    width: 100%;
    padding-top: 100%;
    position: relative;

    img {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  &.Quote__Slider.Quote__Slider .Quote__Text {
    .slick-slide {
      overflow: hidden;
      opacity: 0;
      transition: opacity 300ms ease-out 0s, visibility 300ms ease-out 0s !important;
    }
  }

  // ----- RESPONSIVE ----- //
  @media screen and (max-width: 1680px) {
    .Quote__Inner {
      max-width: 1600px;
    }

    .Logo-Slider {
      max-width: 1600px;

      .Logo-Slider-Item img {
        width: calc(100% - 22px);
      }

      .slick-list {
        margin: 0 -11px;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 96px 0;

    .Logo-Slider,
    .Quote__Inner {
      max-width: 1200px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 96px 16px 80px 16px;

    .Logo-Slider,
    .Quote__Inner {
      max-width: 960px;
    }

    .Quote__Slider-Item-Inner {
      grid-template-columns: repeat(10, minmax(0, 1fr));
      grid-column-gap: 24px;
    }

    .Quote__Slider-Item-Details {
      grid-column: 1 / 8;
    }

    .Quote__Slider-Item-Image-Container {
      grid-column: 8 / 11;
    }

    .Quote__Slider-Prev-Button-Container {
      grid-column: 1;
    }

    .Quote__Slider-Next-Button-Container {
      grid-column: 12;
    }

    .Logo-Slider,
    .Quote__Slider-Outer {
      grid-column: 2 / 12;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 64px 0px;

    .Logo-Slider-Outer,
    .Quote__Text {
      grid-template-columns: repeat(8, minmax(0, 1fr));
      grid-column-gap: 16px;
    }

    .Quote__Slider-Item-Inner {
      grid-template-columns: repeat(6, minmax(0, 1fr));
      grid-column-gap: 16px;
    }

    .Quote__Slider-Item-Details {
      grid-column: 1 / 5;
    }

    .Quote__Slider-Item-Image-Container {
      grid-column: 5 / 7;
    }

    .Logo-Slider {
      grid-column: 1 / 9;
      .Logo-Slider-Item img {
        width: calc(100% - 28px);
      }

      .slick-list {
        margin: 0 -14px;
      }
    }

    .Quote__Slider-Prev-Button-Container {
      grid-column: 1;
    }

    .Quote__Slider-Next-Button-Container {
      grid-column: 8;
    }

    .Quote__Slider-Outer {
      grid-column: 2 / 8;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 64px 0px 79px;

    .Quote__Body-Text {
      margin-bottom: 0;
    }

    .Logo-Slider {
      display: none;
    }

    .Logo-Slider-Outer {
      margin: 0;
    }

    .Quote__Text {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-column-gap: 16px;
      align-items: start;
    }

    .Quote__Slider-Item-Inner {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-column-gap: 16px;
    }

    .Quote__Slider-Item-Details {
      grid-column: 1 / 5;
      display: flex;
      flex-direction: column-reverse;
      > div {
        flex-direction: column-reverse;
        text-align: center;
        margin: 24px 0;

        img {
          margin: 4px 0 0;
        }
      }
    }

    .Quote__Slider-Item-Image-Container {
      grid-column: 2 / 4;
      order: -1;
    }

    .Quote__Slider-Outer {
      grid-row-start: 1;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-column-gap: 16px;
      grid-column: 1 / 5;

      .slick-track {
        display: block;
      }
    }

    .Quote__Slider-Prev-Button-Container,
    .Quote__Slider-Next-Button-Container {
      grid-row-start: 1;
      position: relative;
      padding-top: calc(200% + 18px);
      width: 50%;

      button {
        position: absolute;
        top: 50%;
        width: 48px;
        height: 48px;
        transform: translateY(-50%);
      }
    }

    .Quote__Slider-Prev-Button-Container {
      grid-column: 1 / 2;
      z-index: 1;

      .MuiIconButton-label {
        margin-right: auto;
      }

      button {
        left: 0;
      }
    }

    .Quote__Slider-Next-Button-Container {
      grid-column: 4 / 5;

      button {
        right: 0;
      }
    }

    .Quote__Slider-Prev-Button-Container:hover,
    .Quote__Slider-Next-Button-Container:hover {
      background: none !important;
      cursor: auto;
    }

    .Quote__Slider-Button-Circle:hover {
      cursor: pointer;
      background: ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
    }
  }
`
